export const SCALE_OPTIONS = [
  { id: 'global', label: 'Global', description: 'Worldwide issue affecting multiple countries' },
  { id: 'national', label: 'National', description: 'Issue affecting the entire country' },
  { id: 'state', label: 'State/Regional', description: 'Issue specific to a state or region' },
  { id: 'local', label: 'Local', description: 'Issue affecting local community or city' }
]; 